module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/centros/form.component.css
// module id = ./src/app/centros/form.component.css
// module chunks = main